module.exports = __webpack_public_path__ + "assets/img/pc-white.9db10aef.svg";